
import React, {useEffect} from "react";
import { Container, Row, Col, Breadcrumb } from "react-bootstrap";
import { Link } from "gatsby"
import ContentModule from "../../modules/content_module";

import ShareButton from "../../components/DetailsInfo/ShareButton";

import "./JobDetail.scss";

const JobDetail = ({data, breadcrumbs}) => {

    const shareurl = typeof window !== 'undefined' ? window.location.href : ''
    const instagramShareUrl = `https://www.instagram.com/?url=${shareurl}`

    const handleInstaShare = () => {
        window.open(instagramShareUrl, '_blank');
    };

    const trackerShare = (event) => {    
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'Share - social icons',
          'formType': event + ' - ' +shareurl,
          'formId': 'Share',
          'formName': 'Share',
          'formLabel': 'Share'
        });    
    }

    return (
        <React.Fragment>
            <section className={`insight-section job_details`}>
                <Container>
                    <Row>
                        <Col>
                            <div className="breadcrumb-section">
                                <Breadcrumb>
                                    {/* <Breadcrumb.Item href="javascript:;" className="d-none">Back to Branch Details</Breadcrumb.Item> */}
                                    <li className="breadcrumb-item"><Link to={'/'}>Home</Link></li>
                                    {breadcrumbs?.map((breadcrumb, i, arr) => {
                                        if (arr.length - 1 === i) { // is the last item in the array
                                            return (
                                                <Breadcrumb.Item key={i} active>{breadcrumb.label}</Breadcrumb.Item>
                                            )
                                        } 
                                        else {
                                            return (
                                                <li className="breadcrumb-item"><Link to={`${breadcrumb.url}/`}>{breadcrumb.label}</Link></li>
                                            )
                                        }
                                    })}
                                </Breadcrumb>
                            </div>
                            <div className="content">
                                <div className="heading">
                                    <h1>{data?.title}</h1>
                                    <div className="job_type">
                                        {data?.address?.county && <p><i className="icon-location" /> <b>Location:</b> {data?.address?.county}</p>}
                                        {data?.employment_type && <p><i className="icon-breifcase" /> <b>Job Type:</b> {data?.employment_type}</p>}
                                    </div>
                                </div>
                                

                                <div className="content_wrapper">
                                    <div className="btns_wrapper">
                                        {data?.extra?.applyUrlRoute && <Link to={`https://lomond.talosats-careers.com${data?.extra?.applyUrlRoute}`} target="_blank" className="btn btn-primary"><i className="icon-msg" /> Apply</Link>}
                                        {/* <Link to="" className="btn btn-outline"><i className="icon-share" /> Share</Link> */}
                                        <ShareButton property_data={""} className="share-icon" />
                                    </div>
                                    {data?.description && 
                                        <div className="content_section">
                                            <h3>About this Job</h3>
                                            <ContentModule Content={data?.description} />
                                        </div>
                                    }
                                </div>

                            </div>

                        </Col>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
};
export default JobDetail;